const TableBody = ({
  children,
}: {
  children?: JSX.Element | (JSX.Element | false)[];
}) => {
  return <tbody>{children}</tbody>;
};

export default TableBody;
